import {
    routes
} from "@/router/index";

export default {
    mounted() {

    },
    beforeDestroy() {
        const navItems = document.querySelectorAll("#navLeft .nav-left-item");
        navItems.forEach((v) => {
            v.removeEventListener("mouseover", this.navLeftItemMouseover);
        });
    },
    methods: {
        initNavLeft() {
            this.$nextTick(() => {
                const navItems = document.querySelectorAll("#navLeft .nav-left-item");
                navItems.forEach((v) => {
                    v.addEventListener("mouseover", this.navLeftItemMouseover);
                });
            })
        },
        navLeftItemMouseover(e) {

            const curCategoryId = e.currentTarget.dataset.id;
            // e.currentTarget.classList.add('active')
            this.curCategoryId = curCategoryId
        },

    },
    computed: {
        prevRoute() {
            const matched = this.$route.matched;
            const len = matched.length;
            if (len < 2) {
                return routes.find((v) => {
                    return v.name === matched[0].name;
                });
            }
            return routes.find((v) => {
                return v.name === matched[len - 2].name;
                // return v.name === "dangjian";
            });
        },
    }
}